import React, { Component } from "react";
import {
  Menu,
  MenuItem,
  Button,
  TextField,
  Box,
  InputAdornment,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SearchIcon from '@mui/icons-material/Search';

interface Item {
  key: string;
  value: string;
}

interface MultiLevelDropdownProps {
  selectedItem: string | null;
  setSelectedItem: (item: string | null) => void;
  items: Item[];
  btnCustomStyle?: object;
  menuCustomStyle?: object;
  placeholder: string;
  isAbleToSearch?: boolean;
}

interface MultiLevelDropdownState {
  anchorEl: HTMLElement | null;
  searchTerm: string;
}

export default class CustomSelectDropdown extends Component<MultiLevelDropdownProps, MultiLevelDropdownState> {
  state: MultiLevelDropdownState = {
    anchorEl: null,
    searchTerm: "",
  };

  handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ searchTerm: event.target.value });
  };

  handleItemSelect = (item: string) => {
    this.props.setSelectedItem(item);
    this.handleClose();
  };
  render() {
    const { anchorEl, searchTerm } = this.state;
    const { items, btnCustomStyle = {}, menuCustomStyle = {}, placeholder, isAbleToSearch = false } = this.props;
    const filteredItems = items.filter((item) => item.value.toLowerCase().includes(searchTerm.toLowerCase()));
    
    return (
      <Box>
        <StyledButton 
          onClick={this.handleOpen} 
          endIcon={<KeyboardArrowDownIcon  sx={{ fill: "#94A3B8 !important"}}/>}
          sx={btnCustomStyle}
          >
          {placeholder}
        </StyledButton>

        <StyledMenu 
          anchorEl={anchorEl} 
          open={Boolean(anchorEl)} 
          onClose={this.handleClose}
          sx={{ 
            "& .MuiPaper-root": {
            ...menuCustomStyle,
            "& ul": {
                padding: "0px"
              }
            }
          }}
        >
          { isAbleToSearch && (
              <SearchInput
              size="small"
              placeholder={`Search ${placeholder}`}
              variant="outlined"
              value={searchTerm}
              onChange={this.handleSearchChange}
              onKeyDown={(event) => event.stopPropagation()}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" style={{ marginRight: "4px" }}>
                    <SearchIcon sx={{ width: "16px", height: "16px", color: "#0D0C22" }} />
                  </InputAdornment>
                ),
              }}
            />
          )}
          <StyledScroll>
            {filteredItems.length > 0 ? (
              filteredItems.map((item) => (
              <MenuItem
                key={item.key}
                onClick={() => this.handleItemSelect(item.value)}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "8px 16px",
                  fontFamily: "Montserrat !important",
                  fontSize: "12px !important",
                  fontWeight: "500 !important",
                  lineHeight: "14.63px !important",
                  minHeight: "36px !important",
                  whiteSpace: "break-spaces",
                  "&:hover": {
                    backgroundColor: "#EBC3FF",
                  },
                }}
              >
                {item.value}
              </MenuItem>

            ))) : (
              <MenuItem disabled>No results found</MenuItem>
            )}
          </StyledScroll>
        </StyledMenu>
      </Box>
    );
  }
}



const StyledButton = styled(Button)({
  background: "white",
  border: "1px solid #ccc",
  borderRadius: 8,
  padding: "8px 16px",
  minWidth: "150px",
  color: "#0F172A",
  display: "flex",
  justifyContent: "space-between",
  textTransform: "none",
  fontFamily: "Montserrat !important",
  fontSize: "14px !important",
  fontWeight: "500 !important",
  lineHeight: "22px !important",
  "&:hover": { background: "#f5f5f5" },
});

const StyledMenu = styled(Menu)({
  "& .MuiPaper-root": {
    borderRadius: 8,
    border: "1px solid #CBD5E1",
    boxShadow: "none",
    minWidth: "150px",
    boxSizing: "border-box",
    paddingRight: 0,
    margin: "4px 0px",
    overflowY: "hidden",
  },
});

const SearchInput = styled(TextField)({
  margin: "8px",
  width: "calc(100% - 16px)",
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
    height: 36,
    fontSize: 14,
    paddingLeft: 8,
    paddingRight: 6,
  "& .MuiInputBase-input": {
    paddingRight: 0,
  },
  '&.Mui-focused fieldset': {
        borderColor: '#64748B',
      },
  },
});

const StyledScroll = styled(Box)({
  maxHeight: "242px",
  overflowY: "auto",
  overflowX: "hidden",
  "&::-webkit-scrollbar": {
    width: "5px", // ✅ Make scrollbar thin
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#CBD5E1", // ✅ Light gray color
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#A1A1A1", // ✅ Slightly darker on hover
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent", // ✅ Hide scrollbar track
  },
});
